import { FC, ReactNode } from "react";
import { ExpandableText } from "@/components/ExpandableText";
import { BuilderProps } from "@/types/builder/BuilderProps";

export type ExpandableTextBlockProps = {
  viewMore: string;
  viewLess: string;
  dld?: string;
  dlt?: string;
  linesToShow: number;
  expandTo: "top" | "bottom";
  children: ReactNode;
} & BuilderProps;

export const ExpandableTextBlock: FC<ExpandableTextBlockProps> = (props) => {
  return <ExpandableText {...props}>{props.children}</ExpandableText>;
};
